import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import { SiniestrosEstados } from "./SiniestrosEstados";
import memoize from "memoize-one";
import moment from "moment";

export const Historial = ({ historial, fecha, aseguradora, siniestro, zohoFormItem, creacionFc, ...props }) => {
    const [open, setOpen] = useState(true);
    const openCollapse = () => {
        setOpen(!open);
    };

    const fechaFormato = memoize((fecha, format = "DD/MMM/YYYY") => {
        return fecha ? moment(fecha).locale("moment/locale/es").format(format) : "";
    });

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Estado del Siniestro"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <SiniestrosEstados
                            historial={historial}
                            fecha={fecha}
                            aseguradora={aseguradora}
                            creacionFc={creacionFc}
                            siniestro={siniestro}
                            modal={true}
                            zohoFormItem={zohoFormItem}
                            {...props}
                        />

                        <Table className="adjusttd text-center detallex" responsive>
                            <thead className="text-primary">
                                <tr>
                                    <th>Item</th>
                                    <th className="d-none">transition</th>
                                    <th>Fecha</th>
                                    <th>Estado Anterior</th>
                                    <th>Estado Actualizado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historial.map((hist, index) => (
                                    <tr key={hist.id}>
                                        <td>{index + 1}</td>
                                        <td className="d-none">{hist.transition}</td>
                                        <td>{fechaFormato(hist.fecha)}</td>
                                        <td>{hist.anterior}</td>
                                        <td>{hist.actualizado}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
